





























import Vue from 'vue'
import Component from 'vue-class-component';
import Header from '@/components/Header.vue';
import 'vue-axios';

@Component({
  components: {
    Header,
  },
})
export default class Profile extends Vue {
  executed = false;
  apiMessage = '';

  async callApi(): Promise<void> {
    this.apiMessage = '';

    try {
      const { data } = await this.$http.get('https://blockbuster.qa.cam.simplisafe.com/v1/metadata');

      this.apiMessage = data;
      this.executed = true;
    } catch (err) {
      this.apiMessage = `Error: the server responded with '${err.response.status}: ${err.response.statusText}`;
    }
  }
}

